import * as mg from 'maplibre-gl'
// @ts-ignore
import worker_url from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url'
import Pbf from 'pbf'

import { vt } from 'shared'

import { httpx } from 'api/httpx'

import 'maplibre-gl/dist/maplibre-gl.css'

mg.setWorkerUrl(worker_url)

mg.setRTLTextPlugin('/public/mapbox-gl-rtl-text.js', true)

function zz(v: number): number {
    return (v << 1) ^ (v >> 31)
}

function line_to(v: [number, number][]): number[] {
    return [
        (2 & 0x7) | (v.length << 3),
        ...v.map(([x, y]) => [zz(x), zz(y)]).flat(),
    ]
}

function move_to(x: number, y: number): number[] {
    return [(1 & 0x7) | (1 << 3), zz(x), zz(y)]
}

function index2xy(i: number, box: number): [number, number] {
    let x = 0
    let y = 0

    const T = [
        [0, 0],
        [1, 0],
        [0, 1],
        [1, 1],
    ] as const

    while (true) {
        if (box == 1) break
        box /= 2
        let sec = box * box

        let [bx, by] = T[~~(i / sec)]!
        x += box * bx
        y += box * by
        i %= sec
    }

    return [x, y]
}

const apex_protocol: mg.AddProtocolAction = async (rp, _ac) => {
    let url = rp.url.slice(7)
    let layer_name = url.slice(5).split('/').slice(0, 2).join('_')
    // let [sz, sx, sy] = rp.url.slice(7).split('-')
    // let z = parseInt(sz!)
    // let x = parseInt(sx!)
    // let y = parseInt(sy!)

    let res = await httpx({ url, method: 'GET' })

    // let res = await api_wheat_display_get({ z, x, y })
    // if (!res.ok()) throw new Error('not found')
    // let bits = parseInt(res.headers.get('X-display-bit-count')!) || 0
    // let bits = parseInt(res.headers.get('')!) || 0

    let feats: vt.Feature[] = []

    let bytes = await res.bytes()
    let len = bytes.length
    let box = Math.sqrt(len)

    let values: vt.Value[] = []

    for (let i = 0; i < len; i++) {
        let v = bytes[i]!
        // let byte = bytes[~~(i / 8)]!
        // let bit = 1 << i % 8
        // let v = (byte & bit) == bit
        if (!v) continue
        let kind = v >> 4
        let updated_opacity = (v & 0x0f) / 10

        let tags: number[] = []

        let [x, y] = index2xy(i, box)

        let kv = values.length
        values.push({ uint_value: kind })
        tags.push(0, kv)

        let uv = values.length
        values.push({ double_value: updated_opacity / 2 })
        tags.push(1, uv)

        feats.push({
            type: 'POLYGON',
            tags,
            geometry: [
                ...move_to(x, y),
                ...line_to([
                    [1, 0],
                    [0, 1],
                    [-1, 0],
                ]),
                7,
            ],
        })
    }

    let tile: vt.Tile = {
        layers: [
            {
                name: layer_name,
                keys: ['kind', 'updated'],
                values,
                version: 2,
                extent: box,
                features: feats,
            },
        ],
    }

    let pbf = new Pbf()
    vt.tile_encode(tile, pbf)
    let data = pbf.finish()

    let gres: mg.GetResourceResponse<any> = { data }
    return gres
}
mg.addProtocol('apex', apex_protocol)

const gvec_protocol: mg.AddProtocolAction = async (rp, _ac) => {
    let [sz, sx, sy] = rp.url.slice(7).split('-')

    let z = parseInt(sz!)
    let n = Math.min(21 - z, 1)
    let w = 1 << n
    z += n

    let mx = parseInt(sx!) * w
    let my = parseInt(sy!) * w

    let canvas = document.createElement('canvas')
    canvas.width = 256 * w
    canvas.height = 256 * w
    let ctx = canvas.getContext('2d')!

    for (let x = 0; x < w; x++) {
        for (let y = 0; y < w; y++) {
            let url =
                `https://www.google.com/maps/vt/pb=!1m4!1m3!1i${z}!2i${mx + x}!3i${my + y}` +
                '!2m3!1e0!2sm!3i715999999!3m7!2sen!5e1105!12m4!1e68!2m2!1sset!2sRoadmap!4e0!5m1!1e0!23i202752!23i10205968!23i10208640!23i1368782!23i1368785!23i4861626!23i4897086!23i72613116!23i47054629!23i72385654!23i72310157!23i72458815!23i10211069!23i94243289!23i94255677!23i72692817!23i10210500!23i94222679!23i72767348'

            let img_url = URL.createObjectURL(await (await fetch(url)).blob())
            let img = new Image()

            await new Promise(r => {
                img.onload = () => {
                    ctx.drawImage(img, x * 256, y * 256)
                    URL.revokeObjectURL(img_url)
                    r(1)
                }
                img.src = img_url
            })
        }
    }

    let data = await (await fetch(canvas.toDataURL())).arrayBuffer()

    let gres: mg.GetResourceResponse<any> = { data }
    return gres
}
mg.addProtocol('gvec', gvec_protocol)

const gsat_protocol: mg.AddProtocolAction = async (rp, _ac) => {
    let [sz, sx, sy] = rp.url.slice(7).split('-')

    let z = parseInt(sz!)
    let n = Math.min(21 - z, 1)
    let w = 1 << n
    z += n

    let mx = parseInt(sx!) * w
    let my = parseInt(sy!) * w

    let canvas = document.createElement('canvas')
    canvas.width = 256 * w
    canvas.height = 256 * w
    let ctx = canvas.getContext('2d')!

    for (let x = 0; x < w; x++) {
        for (let y = 0; y < w; y++) {
            let url = `https://khms2.google.com/kh/v=1012?x=${mx + x}&y=${my + y}&z=${z}`

            let img_url = URL.createObjectURL(await (await fetch(url)).blob())
            let img = new Image()

            await new Promise(r => {
                img.onload = () => {
                    ctx.drawImage(img, x * 256, y * 256)
                    URL.revokeObjectURL(img_url)
                    r(1)
                }
                img.src = img_url
            })
        }
    }

    let data = await (await fetch(canvas.toDataURL())).arrayBuffer()

    let gres: mg.GetResourceResponse<any> = { data }
    return gres
}
mg.addProtocol('gsat', gsat_protocol)
